module.exports = __webpack_public_path__ + "static/media/08_noar_mobile.18cca8d3.jpg";